<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-26 14:15:50
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-20 00:33:44
 * @FilePath: /goldenSalesMobile/src/views/RefundOrder/OrderList/index.vue
 * @Description: 退单订单列表
-->
<template>
  <div class="page-container">
    <div class="tab-list">
      <van-tabs
        v-model="activeTabName"
        swipeable
        sticky
        color="var(--tc)"
        title-active-color="var(--tc)"
        title-inactive-color="#666666"
        @change="onTabChange"
      >
        <van-tab
          v-for="(item, index) in tabList"
          swipeable
          :key="index"
          :title="item.title"
          :name="item.statusCode"
          :swipe-threshold="5"
        >
          <van-list
            v-model="loading"
            :error.sync="loadError"
            :finished="finished"
            :offset="30"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              class="order-item"
              v-for="(subItem, subIndex) in item.orderList"
              :key="subIndex"
              @click="onCheckDetail(subItem.Id)"
            >
              <div class="first-line">
                <span>退单号：{{ subItem.Id }}</span>
                <span :class="'status-style-' + subItem.Status.Id">
                  <a>{{ subItem.Status.Name }}</a>
                </span>
              </div>
              <div class="second-line">
                <p v-for="detail in subItem.Details" :key="detail.Id">
                  {{ detail.ProductShelfName }} X {{ detail.Quantity }}
                </p>
              </div>
              <div class="last-line">
                <span v-if="subItem.CreateTime"
                  >创建时间：{{ subItem.CreateTime }}</span
                >
                <span>￥{{ subItem.Amount }}</span>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { getRefundOrderList } from "@/api/refund";
export default {
  data() {
    return {
      loading: false,
      loadError: false,
      finished: false,
      activeTabName: "",
      tabList: [
        {
          title: "全部",
          statusCode: "",
          orderList: [],
        },
        {
          title: "待审核",
          statusCode: 1,
          orderList: [],
        },
        {
          title: "已审核",
          statusCode: 2,
          orderList: [],
        },
        {
          title: "已拒绝",
          statusCode: 3,
          orderList: [],
        },
      ],
      pageIndex: 0,
      pageSize: 10,
    };
  },

  created() {},

  methods: {
    // 上拉加载
    // TODO tab切换之后上拉加载为何会连续触发
    onLoad() {
      // console.log('上拉加载退单列表')
      this.pageIndex++;
      this.getRefundOrders();
    },

    // 加载订单列表
    getRefundOrders() {
      getRefundOrderList({
        query: { Status: this.activeTabName },
        pager: { pageindex: this.pageIndex, pagesize: this.pageSize },
      })
        .then((res) => {
          // console.log(res)
          let data = res.Items;
          if (data instanceof Array) {
            // 把订单数据填充到对应的tabList中
            this.tabList.map((item) => {
              if (item.statusCode === this.activeTabName) {
                if (this.pageIndex > 1) {
                  item.orderList = item.orderList.concat(data);
                } else {
                  item.orderList = data;
                }
              }
            });
            // 没有更多数据时结束上拉加载事件
            if (data.length < this.pageSize || data.length === 0) {
              this.finished = true;
            }
            // 加载结束
            this.loading = false;
          }
        })
        .catch((err) => {
          // console.log(err)
          this.loadError = true;
          this.loading = false;
        });
    },

    // tab切换
    onTabChange(val) {
      this.finished = false;
      this.loading = true;
      this.activeTabName = val;
      this.pageIndex = 0;
      this.getRefundOrders();
    },

    // 查看退单详情
    onCheckDetail(orderId) {
      this.$router.push({
        name: "RefundOrderDetail",
        params: { id: orderId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: $blockBgColor;

  .tab-list {
    margin-bottom: 100px;

    &::v-deep .van-list {
      @include border-box(0 20px);
    }

    .order-item {
      width: 100%;
      box-shadow: 0px 0px 14px 0px rgba(182, 182, 182, 0.5);
      border-radius: 16px;
      margin-top: 20px;
      overflow: hidden;

      > div {
        @include border-box(0 20px);
      }

      .first-line {
        @include flex-box(space-between);
        height: 84px;
        border-bottom: 1px solid #f7f7f7;

        > span:first-child {
          line-height: 40px;
          font-size: 28px;
          font-weight: 500;
          color: $secondFontColor;
        }

        > span:last-child {
          width: 112px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          font-size: 24px;
          font-weight: 500;
          color: #fff;
          border-radius: 8px;
          transform: skewX(-30deg);

          > a {
            display: inline-block;
            transform: skewX(30deg);
          }

          &.status-style-1 {
            background: linear-gradient(to right, #b5bbd0, #d7ddea);
          }

          &.status-style-2 {
            background: linear-gradient(to right, #28a2ff, #76cdff);
          }

          &.status-style-3 {
            background: linear-gradient(to right, #fa9b00, #fbca39);
          }
        }
      }

      .second-line {
        margin: 20px 0;

        > p {
          @include multi-line-ellipsis(2);
          font-size: 30px;
          font-weight: 500;
          color: $secondFontColor;
          line-height: 42px;
        }
      }

      .last-line {
        @include flex-box(space-between);
        margin-bottom: 22px;

        > span:first-child {
          line-height: 40px;
          font-size: 28px;
          color: $baseFontColor;
        }

        > span:last-child {
          line-height: 44px;
          font-size: 32px;
          font-weight: 600;
          color: #fe4600;
        }
      }
    }
  }
}
</style>
